/**
 * Chart and other non-class colors. Values are the CSS variables from
 * design-tokens.json so a token edit updates every chart.
 */
export const chartColor = {
  income: 'var(--cs-color-success)',
  expense: 'var(--cs-color-danger)',
  series: 'var(--cs-color-accent)',
  band: 'var(--cs-color-chart-neutral)',
  grid: 'var(--cs-color-border-strong)',
  tick: 'var(--cs-color-fg-muted)',
  cursor: 'var(--cs-color-accent-muted)',
} as const;

export const chartAxisTick = { fill: chartColor.tick, fontSize: 12 } as const;
